<template>
	<v-menu offset-y offset-x close-on-content-click>
		<template v-slot:activator="{ on, attrs }">
			<v-btn icon dark v-bind="attrs" v-on="on">
				<v-icon large color="#1A237E">mdi-menu</v-icon>
			</v-btn>
		</template>
		<v-list width="125" class="mr-8" dense>
			<v-list-item-group class="text-left"
				v-model="active"
				mandatory
				color="#1A237E">
			<v-list-item v-for="(item, index) in items"
				:key="index"
				:to="item.url">
				<v-list-item-content>
					<v-list-item-title color="#1A237E">
						{{ `${item.title}` | localize }}
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
			</v-list-item-group>
		</v-list>
	</v-menu>	
</template>
<script>
export default {
	data () {
		return {
			on: false,
			active: 0,
			items: [
				{ title: 'About us', url: '/about'},
				/*{ title: 'Partners', url: '/partners'},
				{ title: 'Customers', url: '/customers'}, */
				{ title: 'Media', url: "/media"},
				{ title: 'Contacts', url: "/contacts"}
			],
		}
	},
	computed: {
		locale(state) {
			return state.locale;
		},
	}
}
</script>